(function(){
  function nextBusinessLabel(now){
    var day = now.getDay(), hour = now.getHours();
    if (day === 0 || day === 6) return 'Pazartesi günü kargoda.';
    if (day === 5 && hour >= 16) return 'Pazartesi günü kargoda.';
    if (hour < 16) return 'Bugün 16:00’a kadar sipariş verirsen aynı gün kargoda.';
    return 'Siparişin bir sonraki iş gününde kargoda.';
  }

  function initStockAlert(){
    var iconEl = document.querySelector('[data-stock-icon]');
    var textEl = document.querySelector('[data-stock-text]');
    var barEl = document.querySelector('[data-stock-bar]');

    /* Ürün varyantları JSON'unu oku */
    var variantsJson = null;
    var variantRadiosEl = document.querySelector('variant-radios');
    if (variantRadiosEl) {
      var scriptEl = variantRadiosEl.querySelector('script[type="application/json"]');
      if (scriptEl) {
        try { variantsJson = JSON.parse(scriptEl.textContent); } catch(e) {}
      }
    }

    function updateStock(isAvailable){
      if (!textEl || !barEl) return;
      if (isAvailable === false) {
        if (iconEl) iconEl.textContent = '❌';
        textEl.innerHTML = '<strong>Tükendi:</strong> Bu numara şu an stokta yok.';
        barEl.style.width = '0%';
        barEl.style.background = '#888888';
      } else {
        if (iconEl) iconEl.textContent = '🔥';
        textEl.innerHTML = '<strong>Acele Edin!</strong> Seçtiğiniz numaradan son <strong data-stock-num>1 çift</strong> kaldı.';
        barEl.style.width = '92%';
        barEl.style.background = 'linear-gradient(90deg, #f03e3e, #d62828)';
      }
    }

    function getSelectedVariant(){
      if (!variantsJson || !variantRadiosEl) return null;
      var fieldsets = variantRadiosEl.querySelectorAll('fieldset');
      var selectedOptions = [];
      fieldsets.forEach(function(fs){
        var checked = fs.querySelector('input[type="radio"]:checked');
        if (checked) selectedOptions.push(checked.value);
      });

      for (var i = 0; i < variantsJson.length; i++){
        var v = variantsJson[i];
        var match = true;
        for (var j = 0; j < selectedOptions.length; j++){
          if (v.options && v.options[j] !== selectedOptions[j]) { match = false; break; }
          if (!v.options) {
            var optKey = 'option' + (j + 1);
            if (v[optKey] !== selectedOptions[j]) { match = false; break; }
          }
        }
        if (match) return v;
      }
      return null;
    }

    /* Radio değiştiğinde seçili varyantın stok durumunu kontrol et */
    document.querySelectorAll('.variant-options input[type="radio"], variant-radios input[type="radio"]').forEach(function(radio){
      radio.addEventListener('change', function(){
        var selectedVariant = getSelectedVariant();
        if (selectedVariant) {
          updateStock(selectedVariant.available);
        }
      });
    });

    /* İlk yüklemede de kontrol et */
    var initialVariant = getSelectedVariant();
    updateStock(initialVariant ? initialVariant.available : true);
  }

  function initSocialProofSlider(){
    var slides = document.querySelectorAll('.baytuluk-social-slide');
    if (!slides || slides.length < 2) return;

    var currentIndex = 0;
    setInterval(function(){
      var currentSlide = slides[currentIndex];
      currentIndex = (currentIndex + 1) % slides.length;
      var nextSlide = slides[currentIndex];

      currentSlide.classList.remove('is-active');
      currentSlide.classList.add('is-leaving');

      setTimeout(function(){
        currentSlide.classList.remove('is-leaving');
      }, 450);

      nextSlide.classList.add('is-active');
    }, 3800);
  }

  function init(){
    document.querySelectorAll('[data-baytuluk-delivery-text]').forEach(function(el){
      el.textContent = nextBusinessLabel(new Date());
    });
    document.querySelectorAll('img:not([decoding])').forEach(function(img){
      img.decoding = 'async';
    });
    initStockAlert();
    initSocialProofSlider();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once: true});
  } else {
    init();
  }
})();

/* ==========================================================================
   GLOBAL INSTANT QUICK SIZE SELECTOR MODAL (SIFIR TİTREME / ROCK SOLID)
   ========================================================================== */
window.openBaytulukSizePopup = function(title, price, img, variants) {
  var modal = document.getElementById('GlobalBaytulukSizePopup');
  if (!modal) {
    modal = document.createElement('div');
    modal.id = 'GlobalBaytulukSizePopup';
    modal.className = 'baytuluk-size-popup';
    modal.innerHTML = `
      <div class="baytuluk-size-popup__backdrop" onclick="closeBaytulukSizePopup()"></div>
      <div class="baytuluk-size-popup__dialog">
        <button type="button" class="baytuluk-size-popup__close" onclick="closeBaytulukSizePopup()" aria-label="Kapat">
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
        <div class="baytuluk-size-popup__header">
          <img src="" alt="" id="gbp_img">
          <div class="baytuluk-size-popup__header-text">
            <span class="baytuluk-size-popup__vendor">Kuback</span>
            <h4 class="baytuluk-size-popup__title" id="gbp_title"></h4>
            <div class="baytuluk-size-popup__price" id="gbp_price"></div>
          </div>
        </div>
        <div class="baytuluk-size-popup__body">
          <p class="baytuluk-size-popup__prompt">Ayakkabı Numarası Seçin:</p>
          <div class="baytuluk-size-popup__grid" id="gbp_grid"></div>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
  }

  document.getElementById('gbp_img').src = img;
  document.getElementById('gbp_title').textContent = title;
  document.getElementById('gbp_price').innerHTML = price;

  var grid = document.getElementById('gbp_grid');
  grid.innerHTML = '';

  variants.forEach(function(v) {
    var raw = v.option1 || v.title || '';
    var displaySize = raw.split('/')[0].trim();

    var form = document.createElement('form');
    form.action = '/cart/add';
    form.method = 'post';
    form.className = 'baytuluk-quick-size-form';

    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'id';
    input.value = v.id;
    form.appendChild(input);

    var btn = document.createElement('button');
    btn.type = 'submit';
    btn.className = 'baytuluk-size-btn' + (!v.available ? ' is-disabled' : '');
    if (!v.available) {
      btn.disabled = true;
      btn.title = 'Tükendi';
    }
    btn.innerHTML = '<span class="size-title">' + displaySize + '</span>' + (!v.available ? '<small class="size-sold">Tükendi</small>' : '');
    form.appendChild(btn);

    form.addEventListener('submit', function() {
      setTimeout(closeBaytulukSizePopup, 250);
    });

    grid.appendChild(form);
  });

  setTimeout(function() {
    modal.classList.add('is-open');
    document.body.classList.add('baytuluk-modal-active');
  }, 20);
};

window.closeBaytulukSizePopup = function() {
  var modal = document.getElementById('GlobalBaytulukSizePopup');
  if (modal) {
    modal.classList.remove('is-open');
    document.body.classList.remove('baytuluk-modal-active');
  }
};



